import { render } from "./OrdersStatus.vue?vue&type=template&id=6c555d17&ts=true"
import script from "./OrdersStatus.vue?vue&type=script&lang=ts"
export * from "./OrdersStatus.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__